"use strict";
import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import { randomString } from "../../../utils";
import Tooltip, { TooltipPosition } from "../Tooltip/Tooltip";
import { Label } from "../Label";
import { darkTheme, lightTheme } from "../../../tokens/tokens-css";
import * as styles from "./Toggle-css";
export function Toggle({
  value,
  onChange,
  label,
  labelHidden,
  disabled,
  getDisabledMessage,
  theme,
  className
}) {
  const [disabledMessage, setDisabledMessage] = useState("");
  const toggleId = useRef(`toggle-${randomString()}`);
  const labelId = useRef(`toggle-label-${randomString()}`);
  useEffect(() => {
    if (getDisabledMessage) {
      getDisabledMessage().then((result) => {
        setDisabledMessage(result);
      });
    }
  }, [getDisabledMessage]);
  const renderToggle = () => {
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        className: styles.toggle,
        role: "switch",
        id: toggleId.current,
        "aria-disabled": disabled,
        "aria-checked": value,
        "aria-labelledby": labelId.current,
        onClick: toggleValue,
        disabled,
        type: "button"
      },
      /* @__PURE__ */ React.createElement("div", { className: classNames(styles.handle, lightTheme) })
    );
  };
  const toggleValue = () => {
    onChange?.(!value);
  };
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(className, styles.container({ disabled }), {
        [darkTheme]: theme === "dark",
        [lightTheme]: theme === "light"
      })
    },
    /* @__PURE__ */ React.createElement(
      Label,
      {
        long: true,
        element: "label",
        disabled,
        htmlFor: toggleId.current,
        className: styles.label({ hidden: labelHidden }),
        id: labelId.current
      },
      label
    ),
    disabled ? /* @__PURE__ */ React.createElement(
      Tooltip,
      {
        wrapTarget: true,
        content: disabledMessage,
        show: disabledMessage ? void 0 : false,
        position: TooltipPosition.Bottom
      },
      renderToggle()
    ) : renderToggle()
  );
}
